module.exports = __webpack_public_path__ + "img/smileyvert_off.e4746e3c.gif";